module.exports = __webpack_public_path__ + "static/media/quienes somos.a5532c95.svg";